import axios from 'axios';
import { ElMessage } from 'element-plus';
import type { AxiosResponse } from 'axios';
import store from '@/store/index';
import I18n from '@/locals';

/**
 * @param { baseAxiosURL } 请求头
 * @param { rsa_encrypt_show } 是否非对称加密
 */
interface CustomOptions {
  baseAxiosURL?: string
  rsa_encrypt_show?: boolean
}
let repeat = false
export const request = (options: any, customOptions: CustomOptions = {},) => {
  const { t } = I18n.global;
  return new Promise((resolve, reject) => {
    // create an axios instance
    const baseURL = customOptions.baseAxiosURL == undefined ? '/auth' : customOptions.baseAxiosURL
    const service = axios.create({
      // baseURL: process.env.BASE_API, // api 的 base_url
      baseURL: process.env.VUE_APP_GLOB_API_URL + baseURL,
      timeout: 30 * 1000, // request timeout
    });

    // request interceptor
    service.interceptors.request.use(
      (config: any) => {
        const token = store.state.simulateToken || store.getters.getoken || ''; //此处换成自己获取回来的token，通常存在在cookie或者store里面
        if (token) {
          // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
          config.headers['X-Token'] = token;
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        config.headers.requestOrigin = 'sso';
        config.headers['accept-language'] = store.getters.getLanguageValue;
        config.headers['device'] = 'WEB';
        return config;
      },
      (error) => {
        // Do something with request error
        console.log('出错啦', error); // for debug
        Promise.reject(error);
      }
    );

    // response interceptor
    service.interceptors.response.use(
      (response: AxiosResponse) => {
        if (response.config.responseType === 'blob') {
          return Promise.resolve(response.data);
        } else if (response.data.resultCode != 0) {
          // 每次手动关闭所有弹框
          ElMessage.closeAll();
          ElMessage.error({message: response.data.resultMessage, dangerouslyUseHTMLString: true});
          if (response.data.resultCode === 403) {
            if (!repeat) {
              // token过期  删除缓存
              if (store.state.simulateToken) {
                setTimeout(() => {
                  store.dispatch('removerToken', '');
                }, 1000);
                repeat = true
              } else {
                store.dispatch('removerToken', '');
              }
            }
          }
          return Promise.reject(response.data);
        } else {
          return Promise.resolve(response.data);
        }
      },
      (error) => {
        // 每次手动关闭所有弹框
        ElMessage.closeAll();
        if (error.response.status == 401 || error.response.resultCode == 401) {
          // token过期跳转到登陆
          store.dispatch('removerToken', '');
          ElMessage.error({message: error.response.data.resultMessage || error.response.data.msg, dangerouslyUseHTMLString: true});
        } else {
          ElMessage.error(t('error'));
        }
        return Promise.reject(error.response.data);
      }
    );
    // 请求处理
    service(options)
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  }) as Promise<any>;
};

export default request;
